import { Reveal } from "./Reveal";
import { STEPS } from "../data/content";

export default function Experience() {
    return (
        <section
            id="experienta"
            data-testid="experience"
            className="px-6 py-32 md:px-12 md:py-52"
            style={{ backgroundColor: "var(--bg-2)" }}
        >
            <div className="mx-auto max-w-6xl">
                <Reveal>
                    <span className="eyebrow">Experiența</span>
                    <h2
                        className="mt-6 max-w-2xl font-serif font-light leading-[0.96]"
                        style={{ fontSize: "clamp(2.4rem, 6vw, 5rem)" }}
                    >
                        Cum decurge o programare
                    </h2>
                </Reveal>

                <div className="mt-16 grid grid-cols-1 gap-y-12 md:mt-24 md:grid-cols-4 md:gap-x-10">
                    {STEPS.map((step, i) => (
                        <Reveal key={step.n} delay={i * 0.1}>
                            <div
                                className="border-t pt-6"
                                style={{ borderColor: "var(--ink)" }}
                                data-testid={`step-${step.n}`}
                            >
                                <span
                                    className="font-serif font-light leading-none"
                                    style={{
                                        color: "var(--accent)",
                                        fontSize: "clamp(2.4rem, 4vw, 3.4rem)",
                                    }}
                                >
                                    {step.n}
                                </span>
                                <h3 className="mt-6 font-serif text-2xl font-medium md:text-3xl">
                                    {step.title}
                                </h3>
                                <p
                                    className="mt-3 font-sans text-sm leading-relaxed"
                                    style={{ color: "var(--muted-foreground)" }}
                                >
                                    {step.desc}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
